import { SearchBar } from '../Header/SearchBar';

export const Home = ({searchQuestion, setsearchQuestion}) => {
  return (
  <div className="flex flex-col items-center justify-center h-[90vh]">
    <div className="text-[#57068c] font-bold text-3xl p-2 hover:text-[#ab82c5]">NYU LENR Search Engine</div>
    <SearchBar searchQuestion={searchQuestion} setsearchQuestion={setsearchQuestion}/>
  </div>);
};